// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsValues = {
  values: {
    user: "用户",
    public: "公共",
    tenant: "租户",
    application: "应用",
    shared: "共享",
    sharedOwner: "共享",
    mySpace: "我的空间",
    publicBranding: "公共品牌目录",
    publicShared: "公共共享目录",
    sharedToPublic: "已共享到公共",
    privateOnly: "仅自己可见",
    unlimited: "不限",
    deletable: "可删除",
    protected: "受保护",
    unmanaged: "未纳入治理",
    none: "无",
    active: "启用",
    readonly: "只读",
    disabled: "停用",
    read: "读",
    write: "写",
    manage: "管理",
    ownerOnly: "仅归属方",
    spaceAdmin: "空间管理员",
    platformAdmin: "平台管理员",
    staff: "考务人员",
    platformRole: "平台角色",
  },
} as const;
